import React from 'react';
import { getAwardOrderField } from '../actions';
import { IComponentProps } from './TournamentAwardsList.connector';
import TournamentAwardsListPresentation from './TournamentAwardsListPresentation';

interface IQuery {
  sort: { field: string; order: 'asc' | 'desc' };
  pagination: { page: number; itemsPerPage: number };
}

interface IState {
  query: IQuery;
}

const DEFAULT_QUERY: IQuery = {
  sort: { field: 'tournamentStartDate', order: 'desc' },
  pagination: { page: 1, itemsPerPage: 10 },
};

export class TournamentAwardsList extends React.Component<IComponentProps, IState> {
  private defaultHeaders = [
    { id: 'competition.name', labelKey: 'field_competition' },
    { id: 'tournamentName', labelKey: 'field_tournament' },
    { id: 'winnerTeam.name', labelKey: 'field_winner' },
    { id: 'runnerUpTeam.name', labelKey: 'field_runnerUp' }
  ];

  public state: IState = { query: DEFAULT_QUERY };

  public componentDidMount() {
    this.fetchData();
  }

  public fetchData = () => {
    const { fetchTournamentAwards, filters } = this.props;
    const { sort, pagination } = this.state.query;

    fetchTournamentAwards({
      ...filters,
      [`order[${getAwardOrderField(sort.field)}]`]: sort.order,
      page: pagination.page,
      itemsPerPage: pagination.itemsPerPage,
    });
  };

  public handleSort = (field: string) => {
    const { sort } = this.state.query;
    const order = sort.field === field && sort.order === 'asc' ? 'desc' : 'asc';

    this.setState(
      state => ({
        query: {
          ...state.query,
          sort: { field, order },
          pagination: { ...state.query.pagination, page: 1 },
        },
      }),
      this.fetchData
    );
  };

  public handlePaginate = (change: { page?: number; itemsPerPage?: number }) => {
    this.setState(
      state => ({
        query: {
          ...state.query,
          pagination: {
            page: change.page || state.query.pagination.page,
            itemsPerPage: change.itemsPerPage || state.query.pagination.itemsPerPage,
          },
        },
      }),
      this.fetchData
    );
  };

  public render() {
    const { awards, fetching, headers = this.defaultHeaders, pagination, total, onEdit } = this.props;

    return (
      <TournamentAwardsListPresentation
        awards={awards}
        loading={fetching}
        headers={headers}
        query={this.state.query}
        pagination={pagination}
        total={total}
        onPaginate={this.handlePaginate}
        onSort={this.handleSort}
        onRowClick={onEdit}
      />
    );
  }
}
